import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { GET_FAQS } from "../graphql/Queries/FaqQuery";
import { DELETE_FAQ } from "../graphql/Mutations/FaqMutation";
import { getField } from "../utils/Helper";
import { GET_ESTATE_REJECT_REASONS } from "../graphql/Queries/EstateQuery";
import { DELETE_ESTATE_REJECT_REASON } from "../graphql/Mutations/EstateMutation";

export const EstateRejectReason = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();

  const { data } = useQuery(GET_ESTATE_REJECT_REASONS, {
    fetchPolicy: "no-cache",
  });
  const [drop] = useMutation(DELETE_ESTATE_REJECT_REASON);

  useEffect(() => {
    if (data) {
      setItems(data.estateRejectReason);
    }
  }, [data]);

  const remove = (id) => {
    drop({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteEstateRejectReason);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"Причины отклонения"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  {
                    key: `title`,
                    label: "Название",
                    callback: (item) => {
                      return getField(item, "value");
                    },
                  },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
